export default __webpack_public_path__ + "static/media/video-icon.8fb9ae7b.svg";